export interface Industry {
  slug: string
  name: string
  summary: string
  focus: string
  mandates: string[]
  boardValue: string
}

export const industries: Industry[] = [
  {
    slug: 'banking-financial-services',
    name: 'Banking & Financial Services',
    summary:
      'Institutional alignment, regulatory compliance, and risk mitigation models.',
    focus:
      'Two decades inside tier-1 global institutions, aligning commercial ambition with the standards supervisors and credit committees expect.',
    mandates: [
      'Institutional alignment across regional and global operating models',
      'Regulatory compliance readiness and supervisory engagement',
      'Risk mitigation models spanning credit, operational, and fraud exposure',
      'Working capital, trade, and liquidity solution design',
    ],
    boardValue:
      'A director who can read a regulatory letter and a revenue plan with equal fluency, and tell the board where the two actually conflict.',
  },
  {
    slug: 'technology-enterprise-software',
    name: 'Technology & Enterprise Software',
    summary:
      'Scalable digital architecture, product innovation, and SaaS operational execution.',
    focus:
      'Advisory work with cross-border payment and enterprise platforms, translating product capability into commercial traction.',
    mandates: [
      'Scalable digital architecture and platform roadmap review',
      'Product innovation governance and release discipline',
      'SaaS operational execution: retention, expansion, and unit economics',
      'Go-to-market counsel for regulated and cross-border products',
    ],
    boardValue:
      'Pressure-tests whether a product roadmap will survive contact with enterprise procurement, compliance, and integration reality.',
  },
  {
    slug: 'corporate-governance',
    name: 'Corporate Governance',
    summary:
      'Governance surrounding complex regulatory frameworks and data privacy integration.',
    focus:
      'Governance leadership where regulatory obligation, data sensitivity, and capital intensity intersect.',
    mandates: [
      'Governance over complex, multi-jurisdiction regulatory frameworks',
      'Data privacy integration across systems and third parties',
      'Audit and controls oversight for high-consequence operations',
      'Capital allocation discipline in long-horizon investment cycles',
    ],
    boardValue:
      'Brings audit-committee rigor to environments where a controls failure is a licensing, regulatory, and reputational event at once.',
  },
]

export function getIndustry(slug: string | undefined): Industry | undefined {
  return industries.find((industry) => industry.slug === slug)
}
